import { Navigate, Route, Routes } from "react-router-dom";
import { Home } from "@App/Pages/Partner/Itzehoer/Home";
import { Garages } from "@App/Pages/Common/Garages";
import { Profile } from "@App/Pages/Common/Profile";
import { Contact } from "@App/Pages/Common/Contact";
import { Summary } from "@App/Pages/Common/Summary";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import { PresetFilterRoutes } from "@App/Pages/Partner/Itzehoer/PresetFilterRoutes";
import { CommonRoutes } from "@App/routes/Partner/common";
import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";

export function Itzehoer() {
  const { config } = useOrganizationConfig();

  // URL & Routes
  const root = ":garageBindingType";
  const { navigateWithQuery } = useNavigateWithQueryParams();

  const redirectToRoot = <Navigate to="mwb" replace />;

  return (
    <Routes>
      <Route path={root} element={<PresetFilterRoutes redirectOnMiss={redirectToRoot} />}>
        <Route
          element={
            <DefaultPartnerLayout
              logos={config.navbar.logos}
              backToPartnerButton={config.navbar.backToPartnerButton}
            />
          }
        >
          <Route
            index
            element={
              <Home onSubmit={() => navigateWithQuery(CommonRoutes.garageList.relative, false)} />
            }
          />
          <Route
            path={`/${root}${CommonRoutes.garageList.absolute}`}
            element={
              <Garages
                onSubmit={() =>
                  navigateWithQuery(`../${CommonRoutes.garageProfile.relative}`, true)
                }
              />
            }
          />
          <Route
            path={`/${root}${CommonRoutes.garageProfile.absolute}`}
            element={
              <Profile onSubmit={() => navigateWithQuery(CommonRoutes.checkout.relative, true)} />
            }
          />
          <Route
            path={`/${root}${CommonRoutes.checkout.absolute}`}
            element={
              <Contact onSubmit={() => navigateWithQuery(CommonRoutes.success.relative, true)} />
            }
          />
          <Route path={`/${root}${CommonRoutes.success.absolute}`} element={<Summary />} />
          <Route path={"*"} element={redirectToRoot} />
        </Route>
      </Route>
      <Route path={"*"} element={redirectToRoot} />
    </Routes>
  );
}
